// A Firestore query that needs a composite index fails with FAILED_PRECONDITION
// and a message carrying a console link to create it. That happens in two
// perfectly ordinary situations — the index has not been created on this
// project yet, and the index exists but is still building — so callers that can
// degrade to a client-side filter need to recognise it rather than surface it
// as a hard error.
export const isMissingIndexError = (error) =>
  error?.code === "failed-precondition" ||
  /requires an index/i.test(error?.message || "");
